import { Flex } from '@grupoboticario/flora-react';
import { CheckCircleIcon } from '@grupoboticario/flora-react-icons';

import { ResponsiveFloraTypography } from 'components';
import config from 'config';
import { getLongDate } from 'helpers';
import { useResellerDetail } from 'hooks';
import { useLoyaltyIncentiveCampaign } from 'pages/IncentiveCampaign/hooks';

import Styles from './StaticConfirm.styles';

export const StaticConfirm = () => {
  const { data: incentiveCampaign } = useLoyaltyIncentiveCampaign();
  const { data: resellerDetail } = useResellerDetail();
  const isLoyaltyMember = resellerDetail?.reseller.isLoyaltyMember ?? false;

  const formattedComplianceDate = incentiveCampaign?.complianceDate
    ? getLongDate(incentiveCampaign.complianceDate)
    : '';

  return (
    <Styles.InfoCard>
      <Flex gap='$2'>
        <CheckCircleIcon size={32} />

        <Flex gap='$2' direction='column'>
          <ResponsiveFloraTypography fontSize='subtitle' fontWeight='bold'>
            Sua participação está garantida! As atualizações de progresso ainda não estão
            disponíveis.
          </ResponsiveFloraTypography>
          {!isLoyaltyMember ? (
            <ResponsiveFloraTypography
              fontSize='bodyLargeStandard'
              color='$nonInteractivePredominant'
            >
              Continue comprando para conquistar a premiação dos TOP {incentiveCampaign?.limit}{' '}
              {config.communication.userNamingConvention.plural} por faixa e acumular pontos. É
              preciso estar adimplente até {formattedComplianceDate} para ser elegível a premiação,
              e alcançar pelo menos o primeiro desafio do incentivo para resgate de ponto.
            </ResponsiveFloraTypography>
          ) : (
            <ResponsiveFloraTypography
              fontSize='bodyLargeStandard'
              color='$nonInteractivePredominant'
            >
              Continue comprando para conquistar a premiação dos TOP {incentiveCampaign?.limit}{' '}
              {config.communication.userNamingConvention.plural}. É preciso estar adimplente até{' '}
              {formattedComplianceDate} para ser elegível a premiação.
            </ResponsiveFloraTypography>
          )}
        </Flex>
      </Flex>
    </Styles.InfoCard>
  );
};
